var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82379 2.85667H4.55892C3.14567 2.85667 2 4.00231 2 5.41552V13.9451C2 15.3583 3.14567 16.5039 4.55892 16.5039H13.0887C14.5019 16.5039 15.6476 15.3583 15.6476 13.9451L15.6476 9.68029M6.26487 12.2391L9.36827 11.6138C9.53301 11.5806 9.68429 11.4995 9.80309 11.3806L16.7503 4.42978C17.0834 4.09652 17.0832 3.55633 16.7498 3.22335L15.2782 1.75339C14.9449 1.42055 14.405 1.42077 14.072 1.75389L7.12407 8.70545C7.0055 8.82409 6.92454 8.97505 6.89131 9.13945L6.26487 12.2391Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.50267,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameChange);
export default __webpack_public_path__ + "static/media/NameChange.cf785074cedb75a8f7c79cd26ca24086.svg";
export { ForwardRef as ReactComponent };